import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { Grid, Typography, Button } from '@mui/material';
import ServiceCard from '../Card/ServiceCard';
import { useIntl } from 'react-intl';
import useWindowSize from '../../hooks/useWindowResize';
import { useLanguage } from '../../LanguageContext';

const Services = () => {
	const { $t } = useIntl();
	const { width } = useWindowSize();
	const swiperRef = useRef(null);
	const { locale } = useLanguage();

	const homeServices = [
		{
			image: '/assets/Images/home-services/GoodsForwardingServices.jpg',
			text: $t({ id: 'servicesMainPage1' }),
		},
		{
			image: '/assets/Images/home-services/TransportationApprovalServices.jpg',
			text: $t({ id: 'servicesMainPage2' }),
		},
		// {
		// 	image: '/assets/Images/home-services/GoodsForwardingServices.jpg',
		// 	text: 'ارائه کد مسیر در کشورهای عبوری واگن های صادراتی',
		// },
		{
			image: '/assets/Images/home-services/CustomsClearanceServices.jpg',
			text: $t({ id: 'servicesMainPage3' }),
		},
		{
			image: '/assets/Images/home-services/CustomsConsultingServices.jpg',
			text: $t({ id: 'servicesMainPage4' }),
		},
		{
			image: '/assets/Images/home-services/CargoTransitServices.jpg',
			text: $t({ id: 'servicesMainPage5' }),
		},
	];

	return (
		<Grid
			display={'grid'}
			gap={'40px'}
			px={{ xs: '10px', xxs: '10px', md: '103px' }}
		>
			<Typography
				variant={'h2'}
				display={'flex'}
				justifyContent={'center'}
				fontSize={'25px'}
			>
				{$t({ id: 'servicesTitleMainPage' })}
			</Typography>
			<Grid
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
				gap={'20px'}
				width={{ xs: `${width - 30}px`, xxs: `${width - 40}px`, md: `${width - 230}px` }}
			>
				<Button
					style={{
						rotate: locale === 'fa' ? '180deg' : 0,
					}}
					onClick={() => swiperRef?.current?.swiper.slidePrev()}
				>
					<svg
						width="18"
						height="32"
						viewBox="0 0 18 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.8348 31.3271L0.728149 17.8692C0.485433 17.6199 0.302908 17.3328 0.180579 17.0078C0.0601917 16.6849 0 16.3489 0 16C0 15.6511 0.0601917 15.3141 0.180579 14.9892C0.302908 14.6662 0.485433 14.3801 0.728149 14.1308L13.8348 0.672897C14.2717 0.224299 14.7814 0 15.3639 0C15.9465 0 16.4562 0.224299 16.8931 0.672897C17.3299 1.1215 17.5484 1.64486 17.5484 2.24299C17.5484 2.84112 17.3299 3.36449 16.8931 3.81308L5.02423 16L16.8931 28.1869C17.3299 28.6355 17.5484 29.1589 17.5484 29.757C17.5484 30.3551 17.3299 30.8785 16.8931 31.3271C16.4562 31.7757 15.9465 32 15.3639 32C14.7814 32 14.2717 31.7757 13.8348 31.3271Z"
							fill="#444A5D"
						/>
					</svg>
				</Button>
				<Swiper
					slidesPerView={3}
					spaceBetween={100}
					navigation={true}
					className="services-swiper"
					ref={swiperRef}
					breakpoints={{
						375: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						900: {
							slidesPerView: 1,
							spaceBetween: 50,
						},
						1200: {
							slidesPerView: 2,
							spaceBetween: 50,
						},
					}}
					loop
					modules={[Autoplay]}
					autoplay={{
						delay: 2500,
						disableOnInteraction: false,
					}}
				>
					{homeServices.map(({ image, text }, index) => (
						<SwiperSlide key={index}>
							<ServiceCard {...{ image, text }} />
						</SwiperSlide>
					))}
				</Swiper>
				<Button
					style={{
						rotate: locale !== 'fa' ? '180deg' : 0,
					}}
					onClick={() => swiperRef?.current?.swiper.slideNext()}
				>
					<svg
						width="18"
						height="32"
						viewBox="0 0 18 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.8348 31.3271L0.728149 17.8692C0.485433 17.6199 0.302908 17.3328 0.180579 17.0078C0.0601917 16.6849 0 16.3489 0 16C0 15.6511 0.0601917 15.3141 0.180579 14.9892C0.302908 14.6662 0.485433 14.3801 0.728149 14.1308L13.8348 0.672897C14.2717 0.224299 14.7814 0 15.3639 0C15.9465 0 16.4562 0.224299 16.8931 0.672897C17.3299 1.1215 17.5484 1.64486 17.5484 2.24299C17.5484 2.84112 17.3299 3.36449 16.8931 3.81308L5.02423 16L16.8931 28.1869C17.3299 28.6355 17.5484 29.1589 17.5484 29.757C17.5484 30.3551 17.3299 30.8785 16.8931 31.3271C16.4562 31.7757 15.9465 32 15.3639 32C14.7814 32 14.2717 31.7757 13.8348 31.3271Z"
							fill="#444A5D"
						/>
					</svg>
				</Button>
			</Grid>
		</Grid>
	);
};

export default Services;
